module.exports = __webpack_public_path__ + "img/aboutUs.bb93fcc.webp";